import script from "./SystemStatusPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemStatusPage.vue?vue&type=script&setup=true&lang=ts"

import "./SystemStatusPage.vue?vue&type=style&index=0&id=1f9a7fd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9a7fd6"]])

export default __exports__